// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"74":"25c79e29","201":"3024495f","347":"0aa29389","401":"782c650a","490":"8bc2ac00","592":"4a266144","761":"a8b882b9","779":"38258710","801":"e6195953","871":"88fbcfa3","907":"71e2ff48","980":"18415e13"}[chunkId] + ".js";
};